import { useCallback, useEffect, useMemo } from 'react';

import { Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import Button from '@/components/Buttons/Button';
import GoLogo from '@/components/GoLogo';
import { SUPPORT_EMAIL } from '@/constants/constants';
import { spacing } from '@/constants/ui';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { BaseLayout } from '@/layouts/BaseLayout';
import { CenteredLayout } from '@/layouts/CenteredLayout';
import { useGxTokenFromStorage, useTripTokenFromStorage } from '@/services/storage';
import { logout } from '@/slices/authSlice';
import { clearSelection } from '@/slices/symbolSelectorSlice';

const LOGIN_BUTTON_WIDTH = 250;

const Expired = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const tripToken = useTripTokenFromStorage();
  const gxToken = useGxTokenFromStorage();
  const wasLoggedInOnMount = useMemo(() => Boolean(gxToken || tripToken), [gxToken, tripToken]);

  useEffect(() => {
    if (wasLoggedInOnMount) {
      dispatch(clearSelection());
      dispatch(logout());
    }
  }, [wasLoggedInOnMount, dispatch]);

  const handleLoginClick = useCallback(() => {
    navigate('/login');
  }, [navigate]);

  return (
    <BaseLayout>
      <CenteredLayout>
        <GoLogo size={74} />
        <Typography
          sx={{ textAlign: 'center', mt: spacing[4] }}
          variant='h1'
        >
          Access expired
        </Typography>
        <Typography
          sx={{ my: spacing[2] }}
          variant='subtitle1'
        >
          Login again to get a new link
        </Typography>
        <Button
          sx={{
            width: LOGIN_BUTTON_WIDTH,
            mb: spacing[3]
          }}
          variant='contained'
          onClick={handleLoginClick}
        >
          Go to Login
        </Button>
        <Typography sx={{ textAlign: 'center' }}>
          Any issues? Drop us a line at{' '}
          <Link
            color='text.primary'
            href={`mailto:${SUPPORT_EMAIL}`}
            sx={{ whiteSpace: 'nowrap' }}
            target='_top'
          >
            {SUPPORT_EMAIL}
          </Link>
        </Typography>
      </CenteredLayout>
    </BaseLayout>
  );
};

export default Expired;
